<template>
  <section class="contact-area pb-90">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-box">
            <h3 class="title mb-0">参与项目</h3>
            <div v-if="manuscripts.length > 0">
              <template v-for="(small, index) in events">
                <row-card
                  :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
                  :category="true"
                  :smalldatas="small"
                  :key="index"
                  :type="type"
                />
              </template>
            </div>
            <div v-else>
              <p>暂无参与项目</p>
            </div>
          </div>
        </div>

        <div class="col-lg-12 mt-20">
          <div v-if="totalPages > 1" class="pagination-item">
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <!-- 上一页按钮 -->
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a class="page-link" @click="changePage(currentPage - 1)" href="#" aria-label="Previous">
                    <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                  </a>
                </li>
                <!-- 页码按钮 -->
                <li 
                  v-for="page in visiblePages" 
                  :key="page" 
                  class="page-item" 
                  :class="{ active: page === currentPage }"
                >
                  <a class="page-link" @click="changePage(page)" href="#">{{ page }}</a>
                </li>
                <!-- 下一页按钮 -->
                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                  <a class="page-link" @click="changePage(currentPage + 1)" href="#" aria-label="Next">
                    <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import { 
  getMeManuscripts
 } from '@/api/user';

 import RowCard from "@/components/Utility/Cards/RowCard.vue";

export default {
  components: { RowCard },
  props: {
    profile: {
      type: Object,
      default: () => ({}) // 接收父组件传递的 profile 数据
    }
  },
  data() {
    return {
      manuscripts: [],
      events:[],
      darkClass: {}, 
      type: Number(this.$route.query.type) || 0,
      pageSize: 50,
      currentPage: 1,
      total: 0,
      maxVisiblePages: 5
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
    // 计算可见的页码
    visiblePages() {
      const startPage = Math.max(1, this.currentPage - Math.floor(this.maxVisiblePages / 2));
      const endPage = Math.min(this.totalPages, startPage + this.maxVisiblePages - 1);
      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
  },
  created() {
    this.getManuscripts();
  },
  methods: {
    async getManuscripts() {
      const res = await getMeManuscripts((this.currentPage - 1) * this.pageSize, this.pageSize);
      if (res.code === 200) {
        this.total = res.data.pagination.total;
        console.log('res:', res);
        this.manuscripts = res.list || [];
        const rawEvents = Object.values(res.data.events || {});
        
        // 处理：将每个event与对应的manuscripts合并，生成新的events数组
        this.events = rawEvents.reduce((total, event) => {
          // 找到当前event对应的所有manuscript
          const matchedManuscripts = this.manuscripts.filter(manu => manu.eventid === event.id);
          
          if (matchedManuscripts.length) {
            // 每个manuscript都和event合并，添加自定义字段
            const eventWithManuscripts = matchedManuscripts.map(manuscript => ({
              ...event,
              isParticipated: true,
              manuscriptid: manuscript?.id || null,
              manuscript: manuscript || {},
              settings: {
                allowreg: true,
              }
            }));
            total.push(...eventWithManuscripts); // 把合并后的结果加入总数组
          } else {
            // 没有对应的manuscript，保留原event（可根据需求调整）
            total.push({
              ...event,
              isParticipated: false,
              manuscriptid: null,
              manuscript: {},
              settings: { allowreg: true }
            });
          }
          
          return total;
        }, []); // 初始值是空数组

      } else {
        this.$message({
          message: res.err || '获取项目失败',
          type: 'error'
        });
      }
    },
    // 切换页码的方法
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchEvents();
      }
    },
    // 重置分页信息
    resetPagination() {
      this.currentPage = 1;
    },
  },
  watch: {

  }
};
</script>

<style></style>
